import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "cd-edit-info__container" };
const _hoisted_2 = { class: "cd-edit-info__text" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1);
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { class: "cd-edit-info__content" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerDistributionInfoEdit',
    props: {
        title: {},
        description: {},
        tooltip: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("strong", null, [
                        _createTextVNode(_toDisplayString(props.title) + " ", 1),
                        (props.tooltip)
                            ? (_openBlock(), _createBlock(_component_el_popover, {
                                key: 0,
                                trigger: "hover",
                                placement: "right",
                                width: 260
                            }, {
                                reference: _withCtx(() => [
                                    _hoisted_4
                                ]),
                                default: _withCtx(() => [
                                    _createElementVNode("p", {
                                        innerHTML: props.tooltip
                                    }, null, 8, _hoisted_3)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    (props.description)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            innerHTML: props.description
                        }, null, 8, _hoisted_5))
                        : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "description")
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "default")
                ])
            ]));
        };
    }
});
